






























import { ApiClient } from "@/api/client";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { Route } from "vue-router";
import { mapState } from "vuex";
import ContentList from "@/components/ContentList.vue";
import store from "@/store";

@Component({
  computed: {
    ...mapState(["contentsByCategory", "videoCategories"])
  },
  components: {
    ContentList
  }
})
export default class Categories extends Vue {
  // Mapped from Vuex
  contentsByCategory!: { [key: string]: Content[] };
  videoCategories!: string[];
  isLoading: boolean = false;

  get category(): string {
    return this.$route.params.category;
  }

  get contents(): Content[] {
    if (this.contentsByCategory[this.category]) {
      return this.contentsByCategory[this.category];
    } else {
      return [];
    }
  }

  mounted() {
    this.$Progress.finish();
  }

  // Watchers
  @Watch("$route")
  async onRouteChange(newValue: Route) {
    this.isLoading = true;
    this.$Progress.start();
    this.$Progress.set(30);
    const category = newValue.params.category;
    const client = new ApiClient();
    const contents = await client.getVideosByCategory(category);
    store.commit("setContentsByCategory", {
      category,
      contents
    });
    this.$Progress.finish();
    this.isLoading = false;
  }
}
